export const parseApiResponse = (rawResponse: any) => {
  try {
    // If response is already a proper object, return as-is
    if (typeof rawResponse === 'object' && rawResponse !== null) {
      return rawResponse;
    }

    // If response is string, clean it
    if (typeof rawResponse === 'string') {
      let cleaned = rawResponse.trim();

      // Remove leading "1" only if it is immediately before JSON object
      // Example: 1{"code":"R200"...}
      if (cleaned.startsWith('1{')) {
        cleaned = cleaned.substring(1);
      }

      return JSON.parse(cleaned);
    }

    return rawResponse;
  } catch (error) {
    console.error('Failed to parse API response:', error, rawResponse);
    return rawResponse;
  }
};